// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import userReducer from './slices/user';
import menuReducer from './slices/menu';
import postListReducer from './slices/postList';
import postDetailReducer from './slices/postDetail';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    user: userReducer,
    menu: menuReducer,
    postList: postListReducer,
    postDetail: postDetailReducer
});

export default reducer;
